import React, { useImperativeHandle, useRef, useState, useEffect } from "react";
import { Popup, Position, ToolbarItem } from 'devextreme-react/popup';
import Form, { ButtonItem, FormRef, Item, RangeRule, Label } from 'devextreme-react/form';
import './popupUpdateQtaOrder.scss';
import { OrdiniApi } from '../../data';
import { apiConfiguration } from '../../apiConfig';
import { showError } from '../../utils/errorHandling';
import { FieldDataChangedEvent } from 'devextreme/ui/form';
import { ClickEvent } from 'devextreme/ui/button';
import { useTranslation } from 'react-i18next';

type Props = {
    onChanged: () => void,
    onInserted: () => void
}

export type OrderQtaPopupHandle = {
    edit: (idOrdine: number, idDettaglio: number) => void,
    new: (idOrdine: number, codiceProdotto: string) => void
}

type state = {
    idOrdine: number,
    idDettaglio: number,
    codiceProdotto: string,
    isInsert: boolean;
    isUpdate: boolean;
    visible: boolean
}

const PopupUpdateQtaOrder: React.ForwardRefRenderFunction<OrderQtaPopupHandle, Props> = (props, ref) => {
    const [state, setState] = useState<state>({ idOrdine: 0, idDettaglio: 0, visible: false, codiceProdotto: "", isInsert: false, isUpdate: false });
    const formRef = useRef<FormRef>(null);
    const [formData, setFormData] = useState<any>();
    const { t } = useTranslation();

    function hideInfo() {
        setState({ idOrdine: 0, idDettaglio: 0, codiceProdotto: "", visible: false, isInsert: false, isUpdate: false });
    }

    useImperativeHandle(ref, () => ({

        new(idOrdine, codiceProdotto) {

            setState({
                idOrdine: idOrdine,
                idDettaglio: 0,
                codiceProdotto: codiceProdotto,
                visible: true,
                isInsert: true, 
                isUpdate: false
            });
        },

        edit(idOrdine, idDettaglio) {

            setState({
                idOrdine: idOrdine,
                idDettaglio: idDettaglio,
                codiceProdotto: "",
                visible: true,
                isInsert: false, 
                isUpdate: true
            });
        }
    }));

    useEffect(() => {
        
        setFormData(null);
        if (state.idOrdine && (state.idDettaglio!=0)) {
            const api = new OrdiniApi(apiConfiguration);
            api.getOrdineDettaglioById({
                idOrdine: state.idOrdine,
                idDettaglio: state.idDettaglio
            })
                .catch(showError)
                .then(function (dataresp) {
                    if (dataresp) {
                        setFormData(dataresp);
                    }
                })
                .finally(() => {
                    //                        
                });
        }
        else {
            setFormData({codiceProdotto: state.codiceProdotto, quantita: 0});        
        }

    }, [state.idOrdine, state.idDettaglio]);

    function onFieldDataChanged(e: FieldDataChangedEvent) {
        // if (e.dataField === "dataDocumento" && e.component.getEditor('dataOperazione')?.option('value') == null) {
        //   e.component.updateData("dataOperazione", e.value);
        // }
    }

    function save_click(e: ClickEvent) {
        var validate = formRef.current?.instance().validate();

        if (validate?.isValid) {
            const api = new OrdiniApi(apiConfiguration);
            var data = formRef.current?.instance().option("formData");
            
            if (state.idOrdine && state.idDettaglio==0 && state.codiceProdotto) {
                // console.log('insert')
                api.insertOrdineDettaglio({
                    idOrdine: state.idOrdine,
                    ordineDettaglioCreateDTO: data
                })
                    .catch(showError)
                    .then(function (dataresp) {
                        if (dataresp) {
                            setFormData(dataresp);
                            if (dataresp?.idOrdine) {
                                props.onInserted();
                            }                                
                            setState({
                                idOrdine: Number(dataresp.idOrdine),
                                idDettaglio: Number(dataresp.idDettaglio),
                                codiceProdotto: "",
                                visible: true,
                                isInsert: false, 
                                isUpdate: false
                            });
                        }
                    })
                    .finally(() => {
                        setState({ idOrdine: 0, idDettaglio: 0, visible: false, codiceProdotto: "", isInsert: false, isUpdate: false });
                    });
            }
            else {
                
                api.updateOrdineDettaglio({                    
                    idOrdine: data.idOrdine,
                    idDettaglio: state.idDettaglio,
                    ordineDettaglioUpdateDTO: data
                })
                    .catch(showError)
                    .then((props.onChanged))
                    .finally(() => {
                        setState({ idOrdine: 0, 
                                   idDettaglio: 0, 
                                   codiceProdotto: "",
                                   visible: false,
                                   isInsert: false, 
                                   isUpdate: false });
                    });
            }
        }
    }

    return (<React.Fragment>
        <Popup
            visible={state.visible}
            dragEnabled={false}
            hideOnOutsideClick={true}
            showCloseButton={false}
            showTitle={false}
            fullScreen={false}
            onHidden={hideInfo}
            title={t('modificaqta')}
            container=".dx-viewport"
            height={380}
            width={550}
        >
            <Position
                at="center"
                my="center"
                of=""
                collision="fit"
            />
            <ToolbarItem
                widget="dxButton"
                toolbar="bottom"
                location="center"
                options={{
                    text: t('chiudi'),
                    onClick: hideInfo,
                }}
            />

            <Form id="form" ref={formRef} colCount={1} formData={formData} onFieldDataChanged={onFieldDataChanged} labelMode='floating'>

                <Item dataField="codiceProdotto" isRequired={true} disabled={true} visible={true}>
                    <Label text={t ('codiceProdotto')} />
                </Item>
                <Item dataField="quantita" isRequired={true}>
                    <Label text={t ('quantita')} />
                    <RangeRule min={1}/>    
                </Item>

                <ButtonItem horizontalAlignment="center" colSpan={1}
                    buttonOptions={{
                        text: t('salva'),
                        type: 'success',
                        width: '300px',
                        onClick: save_click,
                        visible: state.visible
                    }}
                />

            </Form>
        </Popup>

    </React.Fragment>
    );
}

export default React.forwardRef(PopupUpdateQtaOrder);

